module.exports=function(scope){ return `var deviceLicenseKeyIdentifier = "THIS_IDENTIFIER_WILL_DEPEND_ON_YOUR_DEVELOPER_ACCOUNT";

// Key text is an extra required paramter for SFTP Log mode only.
// This MUST BE the EXACT text from your Key.  If you modify the text, Key validation will fail.
// 'domains' should match your application's unique bundle identifier.
//
var licenseText = {
    "domains": "<THIS_DOMAIN(s)_WILL_DEPEND_ON_YOUR_SPECIFIC_LICENSE>",
    "expiryDate": "<THIS_DATE_WILL_DEPEND_ON_YOUR_SPECIFIC_LICENSE>",
    "key": "<THIS_KEY_WILL_DEPEND_ON_YOUR_SPECIFIC_LICENSE>"
}
    
// Initialize ZoomSDK using a Device SDK Key - SFTP Log mode
// Verify Key offline.  note that if online Key has previous succeeded, this call will succeed even for invalid Key text.
// @param - licenseText - This is the contents of the actual Key file that FaceTec generated for you. Your Key (s) can be downloaded here -- https://dev.facetec.com/zoomsdk/#/account
// @param - deviceLicenseKeyIdentifier - This is your Device SDK Key Identifier. You can get your Device SDK Key Identifier here: https://dev.facetec.com/zoomsdk/#/account
// @param - initializationSuccessful -  Optional callback to notify caller when FaceTec SDK initialization has completed
//
ZoomSDK.initializeWithLicense(licenseText, deviceLicenseKeyIdentifier, function (initializationSuccessful) {
  console.log("ZoomSDK.initializeWithLicense() success: " + initializationSuccessful + ". Current status: " + ZoomSDK.getStatus());
});
`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/web/00-initialize-prod.js.tpl